"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapping = require('./mapping.json');
exports.light = require('./themes/light.json');
exports.dark = require('./themes/dark.json');
//# sourceMappingURL=index.js.map